// extracted by mini-css-extract-plugin
export default {"container":"styles_container__K37gb","subContainer":"styles_subContainer__h0rYB","subtitle":"styles_subtitle__mtgFE","paragraph":"styles_paragraph__-hYfo"};